module.exports = __webpack_public_path__ + "img/hot_dzp.a6f31e90.svg";